App.Views.Dialog = {
  Calendar: {},
};
